import * as z from "zod";

const BadgeSchema = z.object({
  ImageUrl: z.url(),
  Url: z.url().nullable(),
});

export const EstablishmentThemeSchema = z.object({
  FullName: z.string(),
  LogoUrl: z.url(),
  FaviconUrl: z.url(),
  Color: z.string(),
  Badges: z.array(BadgeSchema).optional().default([]),
});
